import Vue from 'vue';
import axios from 'axios';
import * as moment from 'moment';
import VueGeolocation from 'vue-browser-geolocation';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import * as VueGoogleMaps from 'gmap-vue';
import { gmapApi } from 'gmap-vue';
import { MarkerClusterer, GridAlgorithm } from "@googlemaps/markerclusterer";
import { ToggleButton } from 'vue-js-toggle-button'
import 'vue-simple-suggest/dist/styles.css'; // Optional CSS
import dayMapStyle from '../../../json/dayStyle.json'
import darkMapStyle from '../../../json/darkStyle.json'
import VueObserveVisibility from 'vue-observe-visibility'
import VueRouter from 'vue-router';
import Snotify from 'vue-snotify';
import 'vue-snotify/styles/material.css'
import VueSimpleSuggest from 'vue-simple-suggest'

Vue.component('ToggleButton', ToggleButton)

Vue.use(VueGeolocation);
Vue.use(Loading);
Vue.use(VueObserveVisibility);
Vue.use(VueRouter);
Vue.use(Snotify);

var router = new VueRouter({
    mode: 'history',
    routes: []
});

Vue.use(VueGoogleMaps, {
    load: {
        v: '3.63',
        key: 'AIzaSyB2AR_DQXGIBLWEnzlKAIVQhngBPvjYmCs',
        loading: 'async',
        region: 'NO',
        language: 'no',
        libraries: 'visualization',
        installComponents: 'true'
    }
});

Vue.filter('toTons', function (value) {
    if (value < 1000) {
        return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kg';
    }
    else if (value < 10000) {
        return (value / 1000).toFixed(1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' tonn';
    }
    return Math.round(value / 1000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' tonn';
});

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY');
    }
});

Vue.filter('formatDateTime', function (value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY - HH:mm');
    }
});

Vue.filter('formatSize', function (value) {
    if (value) {

        if (/^[-][0-9]{1,}.{0,}$/.test(value)) {
            return 'Under ' + value.substring(1).toLowerCase();
        }

        if (/^.{1,}[+].{0,}$/.test(value)) {
            return 'Over ' + value.replace("+", "").toLowerCase();
        }

        if (/^.{1,}[-].{1,}$/.test(value)) {
            return value.toLowerCase();
        }
    }
    return value;
});

Vue.filter('totalWeight', function (item) {
    if (item) {
        try {
            return item.groups.reduce((acc, row) => acc + row.weight, 0);
        } catch (e) {
            return 0;
        }
    }
    return 0;
});

var dayStyle = dayMapStyle

var darkStyle = darkMapStyle

var infowindow = null

var app = new Vue({
    router,
    el: '#clusterMap',

    components: {
        Loading,
        VueSimpleSuggest
    },

    data: {
        mapStyle: { mapTypeControl: false, styles: dayStyle },
        mapCenter: { lat: 67.151621, lng: 18.959998 },
        showVessels: false,
        showHeatMap: false,
        showModal: false,
        darkMode: false,
        markers: null,
        markerOptions: {
            url: '/img/icons/map/RFLcolors/gmapMarker_red.png',
            scaledSize: { width: 27, height: 43, f: 'px', b: 'px', },
        },
        mapReference: null,
        mapMarkersReference: null,
        clusterLayerReference: null,
        heatLayerReference: null,
        points: [],
        heatPoints: [],
        totalWeight: 0,
        preSelectedWarehouse: null,
        warehouseData: null,
        vesselList: null,
        selectedVesselData: null,
        searchString: '',
        suggestionVesselText: '',
        suggestionWarehouseText: '',
        selectedSuggestionItem: null,
        searchTableString: '',
        searchVesselTableString: '',
        elToScroll: null,
        isMapApiError: false,
        urlParamWarehouse: null,
        fishList: null,
        selectedFish: null,
    },

    computed: {
        searchPoints() {
            return this.points.filter(p => p.name.toLowerCase().includes(this.searchString.toLowerCase()) || p.id.toLowerCase().includes(this.searchString.toLowerCase()) || p.buyer.toLowerCase().includes(this.searchString.toLowerCase()));
        },

        searchVessels() {
            if (this.vesselList !== null) {
                return this.vesselList.filter(v => v.vessel.toLowerCase().includes(this.searchString.toLowerCase()) || v.registrationMark.toLowerCase().replace(/\s+/g, '').includes(this.searchString.toLowerCase().replace(/\s+/g, '')));
            }
            return []
        },

        selectedWarehouse() {
            return this.warehouseData === null ? null : this.warehouseData[0].warehouseId;
        },

        selectedVessel() {
            return this.selectedVesselData === null ? null : this.selectedVesselData[0].registrationMark;
        },

        warehouseDataTable() {
            if (this.warehouseData !== null) {
                var resultGroups = this.multipleGroupByWarehouse(this.warehouseData, (property) => [property.registrationMark, property.date]);
                return resultGroups;
            }
            //return this.warehouseData.filter(w => w.fishType.toLowerCase().includes(this.searchTableString.toLowerCase()) || w.vessel.toLowerCase().includes(this.searchTableString.toLowerCase()) || w.registrationMark.toLowerCase().includes(this.searchTableString.toLowerCase()));
        },

        vesselDataTable() {
            if (this.selectedVesselData !== null) {
                var resultGroups = this.multipleGroupByVessel(this.selectedVesselData, (property) => [property.warehouseId, property.date]);
                return resultGroups;
                //return this.selectedVesselData.filter(v => v.fishType.toLowerCase().includes(this.searchVesselTableString.toLowerCase()) || v.warehouseName.toLowerCase().includes(this.searchVesselTableString.toLowerCase()));
            }

        },

        suggestionsVesselFilter() {
            var self = this;
            if (self.suggestionVesselText !== '') {
                var searchString = self.suggestionVesselText.replace(/\s+/g, '').toLowerCase();
                return self.vesselList.filter(v => v.vessel.replace(/\s+/g, '').toLowerCase().includes(searchString) || v.registrationMark.replace(/\s+/g, '').toLowerCase().includes(searchString)).slice(0, 5);
            }
            else {
                return [];
            }
        },

        suggestionsWarehouseFilter() {
            var self = this;
            if (self.suggestionWarehouseText !== '') {
                var searchString = self.suggestionWarehouseText.replace(/\s+/g, '').toLowerCase();
                return self.points.filter(p => p.name.replace(/\s+/g, '').toLowerCase().includes(searchString) || p.id.replace(/\s+/g, '').toLowerCase().includes(searchString) || p.buyer.replace(/\s+/g, '').toLowerCase().includes(searchString)).slice(0, 5);
            }
            else {
                return [];
            }
        },

        selectedFishName() {
            var self = this;
            return self.selectedFish ? self.selectedFish.Fish : '';
        }
    },

    watch: {
        markers: function (val) {
            if (val !== null && val.length > 0) {
                //console.log(val);
                this.loadPoints();
                if (this.fishList == null) {
                    this.getFishList();
                }
            }
        },

        fishList: function (val) {
            if (val !== null && val.length > 0) {
                console.log(val);
            }
        },

        selectedFish: function (newVal, oldVal) {
            var self = this;
            console.log(newVal == oldVal);
            self.getMarkers(self.selectedFishName);
        },

        points: function (val) {
            //console.log(val);
            if (this.urlParamWarehouse !== null && val.some(e => e.id === this.urlParamWarehouse)) {
                this.toggleWarehouseInfo(this.urlParamWarehouse);
            }
            this.addMarkersAndClusters();
        },

        isMapApiError: function (val) {
            //if (val) {
            //    this.displayWarningNotification('Kartet er ikke tilgjengelig for øyeblikket');
            //}
            //console.log(val);
        },

        warehouseData: function (val) {
            //console.log(val);
            if (!val) {
                this.urlParamWarehouse === null;
                this.preSelectedWarehouse = null;
                infowindow.close();
            }

            this.collapseAll();
        },

        showVessels: function (val) {
            this.searchString = '';
            if (val && !this.vesselList) {
                this.getVessels();
            }
            else if (!val && !this.markers) {
                this.getMarkers();
            }
        },

        vesselList: function (val) {
            //console.log(val);
        },

        selectedVesselData: function (val) {
            // collapse all on vessel data change
            this.collapseAll();

            //console.log(val);
        },

        darkMode: function (val) {
            if (val) {
                this.mapReference.setOptions({ styles: darkStyle });
            }
            else {
                this.mapReference.setOptions({ styles: dayStyle });
            }
        },

        showHeatMap: function (val) {
            if (val) {
                this.clusterLayerReference.clearMarkers();
                this.clusterLayerReference.setMap(null);
                this.heatLayerReference.setMap(this.mapReference);
                this.mapReference.setZoom(5);
                this.mapReference.panTo(this.mapCenter);
            }
            else {
                this.heatLayerReference.setMap(null);
                this.clusterLayerReference.setMap(this.mapReference);
                this.clusterLayerReference.addMarkers(this.mapMarkersReference);
            }
        }
    },

    methods: {
        // react to selecting of vessel in suggestion list
        selectVesselSuggestion(vessel) {
            if (!vessel) {
                this.clearVesselData();
            }
            else {
                this.toggleVesselInfo(vessel, true);
                this.suggestionVesselText = '';
            }
        },

        // react to selecting of warehouse in suggestion list
        selectWarehouseSuggestion(warehouse) {
            if (!warehouse) {
                this.selectedWarehouse = null;
            }
            else {
                this.toggleWarehouseInfo(warehouse.id, true);
                this.suggestionWarehouseText = '';
            }
        },

        getMarkers: function (fishName = '') {
            let loader = this.$loading.show({
                loader: 'spinner',
                color: '#007bff'
            });
            axios.get('/umbraco/Surface/Map/GetBasicReceptions/', { params: { fishName: fishName } })
                .then((response) => {
                    if (response.data !== 'error') {
                        this.markers = response.data;
                    }
                    else {
                        this.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log(response.data);
                    }
                    loader.hide();
                })
                .catch(function (error) {
                    this.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                    loader.hide();
                    console.log(error);
                });
        },

        getFishList: function () {
            let loader = this.$loading.show({
                loader: 'spinner',
                color: '#007bff'
            });
            axios.get('/umbraco/Surface/Map/GetFishWeightSummary/')
                .then((response) => {
                    if (response.data !== 'error') {
                        this.fishList = response.data;
                    }
                    else {
                        this.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log(response.data);
                    }
                    loader.hide();
                })
                .catch(function (error) {
                    this.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                    loader.hide();
                    console.log(error);
                });
        },

        clearFishSelection: function () {
            console.log('clear fish');
            this.selectedFish = null;
        },

        handleInputEvent: function (value) {
            // If the emitted value is empty, the input was cleared
            if (!value) {
                this.clearFishSelection();
            }
        },

        getVessels: function () {
            let loader = this.$loading.show({
                loader: 'spinner',
                color: '#007bff'
            });
            axios.get('/umbraco/Surface/Map/GetBasicVessels/', { params: { fishName: this.selectedFishName } })
                .then((response) => {
                    if (response.data !== 'error') {
                        //console.log(response.data);
                        this.vesselList = response.data;
                    }
                    else {
                        this.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log(response.data);
                    }
                    loader.hide();
                })
                .catch(function (error) {
                    this.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                    loader.hide();
                    console.log(error);
                });
        },

        getWarehouseData: function (id) {
            let loader = this.$loading.show({
                loader: 'spinner',
                color: '#007bff'
            });
            axios.get('/umbraco/Surface/Map/GetWarehouseData', { params: { id: id, fishName: this.selectedFishName } })
                .then((response) => {
                    if (response.data !== 'error') {
                        //console.log(response.data);
                        this.warehouseData = response.data;
                    }
                    else {
                        this.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log(response.data);
                    }
                    loader.hide();
                })
                .catch(function (error) {
                    this.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                    loader.hide();
                    console.log(error);
                });
        },

        getVesselData: function (id) {
            let loader = this.$loading.show({
                loader: 'spinner',
                color: '#007bff'
            });
            axios.get('/umbraco/Surface/Map/GetVesselData', { params: { id: id, fishName: this.selectedFishName } })
                .then((response) => {
                    if (response.data !== 'error') {
                        //console.log(response.data);
                        this.selectedVesselData = response.data;
                    }
                    else {
                        this.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                        console.log(response.data);
                    }
                    loader.hide();
                })
                .catch(function (error) {
                    this.displayErrorNotification('Databasefeil, vennligst prøv igjen senere.')
                    loader.hide();
                    console.log(error);
                });
        },

        loadPoints: function () {
            var self = this;
            self.heatPoints = self.markers.map(m => { return { location: new google.maps.LatLng({ lat: m.lat, lng: m.lng }), weight: m.weight } });
            self.points = self.markers.map(m => { return { id: m.warehouseId, name: m.warehouseName, buyer: m.buyerName, lat: m.lat, lng: m.lng, weight: m.weight, zone: m.zone, lastDeliveryDate: m.date } });
            var totalWeight = self.markers.reduce((accumulator, current) => accumulator + current.weight, 0);
            self.totalWeight = Math.round(totalWeight / 1000);
        },

        getPosition: function (marker) {
            return {
                lat: parseFloat(marker.lat),
                lng: parseFloat(marker.lng)
            };
        },

        showDetails: function (warehouseId) {
            var self = this;
            self.toggleWarehouseInfo(warehouseId);
        },

        toogleMapType: function () {
            var self = this;
            self.clearWarehouseData();
            self.showHeatMap = !self.showHeatMap;
        },

        toogleMapMode: function () {
            var self = this;
            self.darkMode = !self.darkMode;
        },

        toogleModal: function () {
            var self = this;
            self.showModal = !self.showModal;
        },

        toogleVesselMode: function () {
            var self = this;
            self.showVessels = !self.showVessels;
            self.collapseAll();
            self.searchString = '';
        },

        // show data table for selected warehouse
        toggleWarehouseInfo: function (warehouseId, scroll = false) {
            var self = this;
            if (this.selectedWarehouse !== warehouseId) {
                self.getWarehouseData(warehouseId);
                if (scroll) {
                    self.scrollToElement(warehouseId);
                }
            }
            else {
                self.clearWarehouseData();
            }
        },

        // show data table for selected vessel
        toggleVesselInfo: function (vessel, scroll = false) {
            var self = this;
            if (self.selectedVessel !== vessel.registrationMark) {
                self.getVesselData(vessel.registrationMark);
                if (scroll) {
                    self.scrollToElement(vessel.registrationMark);
                }
            }
            else {
                self.clearVesselData();
            }
        },

        // show map info window for selected warehouse or show data table if google maps api returns error, clear data & unzoom map if heat map is selected
        toggleInfo: function (point) {
            var self = this;
            if (!self.showHeatMap) {
                if (self.selectedWarehouse !== point.id) {
                    if (self.isMapApiError) {
                        self.showDetails(point.id);
                    }

                    else if (markerToShow && !self.warehouseData) {
                        var markerToShow = self.mapMarkersReference.filter(m => m.id === point.id);
                        markerToShow = markerToShow[0];
                        self.showInfo(self.mapReference, markerToShow)
                    }

                    else {
                        self.showDetails(point.id);
                    }
                }
                else {
                    self.clearWarehouseData();
                }

            }
            else {
                if (self.selectedWarehouse === point.id) {
                    self.clearWarehouseData();
                }
                else {
                    self.getWarehouseData(point.id);
                    self.mapReference.setZoom(11);
                    self.mapReference.panTo(new google.maps.LatLng(point.lat, point.lng));
                }
            }
        },

        clearWarehouseData: function () {
            this.warehouseData = null;
        },

        clearVesselData: function () {
            this.selectedVesselData = null;
        },

        // shows map marker info window for selected warehouse
        showInfo: function (map, marker, scroll = false) {
            var self = this;

            // unselect if same warehuse is selected
            if (self.preSelectedWarehouse === marker.id) {
                infowindow.close();
                self.preSelectedWarehouse = null;
                self.elToScroll = null;
            }
            else {
                infowindow.close();
                var isInCluster = self.isMarkerClustered(marker, self.clusterLayerReference); // check if marker is in cluster (determine if zooming of map is necessary)
                var nameString = marker.name !== '' ? '<h6 class="font-weight-bold mb-1">' + marker.name + '</h6>' : ""
                var zoneString = marker.zone !== '' ? '<div>' + marker.zone + '</div>' : ""
                var weightString = marker.weight !== '' ? '<h6 class="font-weight-bold mt-3">Total vekt: ' + self.$options.filters.toTons(marker.weight) + '</h6>' : ""
                var detailsBtn = '<div class="centeredContent mt-3"><input type="button" class="rounded" value="Se siste leveranser" onclick="showDetails(\'' + marker.id + '\')"/></div>'
                infowindow.setContent('<div class="infoWindowContent p-3">' + nameString + zoneString + weightString + detailsBtn + '</div>');
                self.preSelectedWarehouse = marker.id;
                if (isInCluster) {
                    self.mapReference.setZoom(11);
                }
                self.mapReference.panTo(marker.position); // scroll map to selected marker
                infowindow.addListener("closeclick", () => {
                    self.preSelectedWarehouse = null;
                });
                infowindow.open(map, marker);
                if (scroll) {
                    self.scrollToElement(marker.id);
                }
            }
        },

        // scroll sidebar to selected element
        scrollToElement: function (elName) {
            var el = document.getElementById(elName);
            if (el) {
                el.scrollIntoView(true);
            }

            this.elToScroll = elName;
        },

        // prepare google map with markers and clusters
        addMarkersAndClusters: function () {
            var self = this;
            var markerClusterer = null;
            var heatMap = null;

            var map = new google.maps.Map(document.getElementById('map'), {
                zoom: 5,
                minZoom: 4,
                center: self.mapCenter,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                streetViewControl: false,
                mapTypeControl: false,
                styles: dayStyle
            });

            var markers = [];
            for (var i = 0; i < self.points.length; i++) {

                var latLng = new google.maps.LatLng(self.points[i].lat, self.points[i].lng);
                var marker = new google.maps.Marker({
                    id: self.points[i].id,
                    name: self.points[i].name,
                    position: latLng,
                    icon: self.markerOptions,
                    weight: self.points[i].weight,
                    zone: self.points[i].zone
                });
                markers.push(marker);
            }

            // custom cluster calculation method (calculates weights instead of number of markers inside cluster)
            var calc = function (markers, numStyles) {
                var weight = 0;

                for (var i = 0; i < markers.length; ++i) {
                    weight += markers[i].weight;
                }

                // convert to tons
                weight = Math.round(weight / 1000);

                return {
                    text: weight,
                    //index of style cluster should have
                    index: Math.min(String(weight).length, numStyles)
                };
            }

            var algorithm = new GridAlgorithm({});

            const svg = window.btoa(`
                <svg fill="#4085c0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                 <circle cx="120" cy="120" r="120" stroke="#4085c0" stroke-width="2" fill="#4085c075" />
                </svg>`);

            const renderer = {
                palette: { minRadius: 45, maxRadius: 105 },
                render: function (cluster, stats) {
                    const clusterWeight = Math.round(cluster.markers.reduce((accumulator, object) => {
                        return accumulator + object.weight / 1000;
                    }, 0))
                    const weightRatio = clusterWeight.toString().length;
                    const radius = weightRatio < 3 ? 60 : weightRatio < 4 ? 75 : weightRatio < 5 ? 90 : 105;
                    return new google.maps.Marker({
                        label: {
                            text: String(clusterWeight) + " \ntonn", color: "white", fontSize: "15px",
                            className: 'custom-clustericon',
                        },
                        title: String(cluster.count),
                        icon: {
                            url: `data:image/svg+xml;base64,${svg}`,
                            scaledSize: new google.maps.Size(radius, radius),
                        },
                        position: cluster.position,
                        // adjust zIndex to be above other markers
                        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + cluster.count,
                    });
                },
            };

            markerClusterer = new MarkerClusterer({ algorithm, map, markers, renderer });
            self.clusterLayerReference = markerClusterer;

            heatMap = new google.maps.visualization.HeatmapLayer({
                data: self.heatPoints,
                radius: 30
            });

            self.heatLayerReference = heatMap;

            self.setInfoWindow(map, markers, self.showInfo);
        },

        setInfoWindow: function (map, markers, showInfo) {
            markers.forEach(function (marker) {
                marker.addListener("click", () => {
                    showInfo(map, marker, true);
                });
            });
            this.mapReference = map;
            this.mapMarkersReference = markers;
        },

        // check if marker is in one of the clusters or stands alone
        isMarkerClustered(marker, clusterer) {
            const clusters = clusterer.clusters;
            for (let i = 0, l = clusters.length; i < l; i++) {
                const markers = clusters[i].markers;
                for (const m of markers) {
                    if (m === marker && markers.length > 1) {
                        return true;
                    }
                }
            }
            return false;
        },

        visibilityChanged(isVisible, entry) {
            var self = this;
            if (isVisible && self.elToScroll !== null) {
                var elMobile = document.getElementById(self.elToScroll + 'mobile');
                if (elMobile) {
                    elMobile.scrollIntoView(true);
                    document.getElementById('clusterModal').scrollTop = 0;
                }
            }
        },

        modalClick(target) {
            if (target.id === 'clusterModal') {
                this.toogleModal();
            }
        },

        // react to url with params
        getUrlParams() {
            var parameters = this.$route.query
            if (parameters) {
                if (parameters.viewType) {
                    this.showVessels = parameters.viewType === '2' ? true : false;
                }
                else if (parameters.wId) {
                    this.urlParamWarehouse = parameters.wId;
                    this.getMarkers();
                }
                else if (parameters.fId) {
                    this.selectedFish =
                        {
                            Fish: parameters.fId,
                            Weight: 1
                        }
                    }
                else {
                    this.getMarkers();
                }
            }
        },

        // create groups based on time of delivery for vessel (used for collapsible elements)
        multipleGroupByVessel(dataArray, groupPropertyArray) {
            const groups = {};
            dataArray.forEach(item => {
                const group = JSON.stringify(groupPropertyArray(item));
                groups[group] = groups[group] || [];
                groups[group].push(item);
            });
            var result = Object.keys(groups).map(function (group) { return { id: groups[group][0].id, name: groups[group][0].warehouseName, date: groups[group][0].date, groups: groups[group] } });

            return result;
        },

        // create groups based on time of delivery for warehouse (used for collapsible elements)
        multipleGroupByWarehouse(dataArray, groupPropertyArray) {
            const groups = {};
            dataArray.forEach(item => {
                const group = JSON.stringify(groupPropertyArray(item));
                groups[group] = groups[group] || [];
                groups[group].push(item);
            });
            var result = Object.keys(groups).map(function (group) { return { id: groups[group][0].id, name: groups[group][0].vessel, regMark: groups[group][0].registrationMark, date: groups[group][0].date, groups: groups[group] } });
            return result;
        },

        // collapses all expanded rows in data table (for selected warehouse or vessel)
        collapseAll() {
            try {
                var triggers = this.$el.getElementsByClassName('activeCollapse');
                var panels = this.$el.getElementsByClassName('panel-collapse');
                for (var i = 0; i < panels.length; i++) {
                    triggers[i].setAttribute('aria-expanded', false);
                    panels[i].classList.remove('show');
                }
            } catch (e) {
                return;
            }
        },

        displayErrorNotification(error) {
            this.$snotify.error(error, {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
        },

        displayWarningNotification(warning) {
            this.$snotify.warning(warning, {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
        },
    },

    created() {
        let self = this;
        window.showDetails = function (warehouseId) {
            self.showDetails(warehouseId);
        }

        window.gm_authFailure = () => {
            self.isMapApiError = true;
        };

        window.addEventListener('gmapi_error', function () {
            self.isMapApiError = true;
        });

    },

    async mounted() {
        var self = this;
        await self.$gmapApiPromiseLazy();
        infowindow = new google.maps.InfoWindow({});
        //self.getMarkers();
        self.getUrlParams();
    }
});


// WEBPACK FOOTER //
// ./Scripts/app/clusterMap/index.js